import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getFeaturedEvents } from "@/utils/events";

export default function HeroCarousel() {
  const featured = getFeaturedEvents(3);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % featured.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [featured.length]);

  const current = featured[index];

  const goTo = (next: number) => {
    setIndex((next + featured.length) % featured.length);
  };

  return (
    <section className="relative w-full">
      <div className="relative h-[520px] w-full overflow-hidden md:h-[600px]">
        {featured.map((event, i) => (
          <div
            key={event.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === index ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={event.cover}
              alt={`${event.title} 焦点赛事`}
              title={`${event.title} 赛事资讯`}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/30"></div>
          </div>
        ))}

        <div className="relative z-10 mx-auto flex h-full max-w-[1280px] flex-col justify-center px-4 md:px-6">
          <div className="max-w-2xl animate-fade-up">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-foreground-950">
                <i className="ri-live-line"></i>今日焦点
              </span>
              <span className="rounded-full border border-background-50/30 px-3 py-1 text-xs font-medium text-background-100">
                {current.category}
              </span>
              <span className="rounded-full border border-background-50/30 px-3 py-1 text-xs font-medium text-background-100">
                {current.status}
              </span>
            </div>

            <h1 className="mt-5 font-heading text-3xl font-extrabold leading-tight text-background-50 md:text-5xl">
              {current.title}
            </h1>

            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
              {current.summary}
            </p>

            <div className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-background-100">
              <span className="flex items-center gap-2">
                <i className="ri-calendar-line text-accent-400"></i>
                {current.date}
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400"></i>
                {current.venue}
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-team-line text-accent-400"></i>
                {current.teams.join(" / ")}
              </span>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <Link
                to={`/detail/${current.id}`}
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-400"
              >
                查看赛事详情
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/category"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
              >
                浏览全部赛事
              </Link>
            </div>
          </div>
        </div>

        <div className="absolute bottom-16 right-4 z-10 hidden items-center gap-3 md:flex md:right-6">
          <button
            type="button"
            onClick={() => goTo(index - 1)}
            aria-label="上一个焦点赛事"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-background-50/40 text-background-50 transition-colors hover:bg-background-50/15"
          >
            <i className="ri-arrow-left-line"></i>
          </button>
          <button
            type="button"
            onClick={() => goTo(index + 1)}
            aria-label="下一个焦点赛事"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-background-50/40 text-background-50 transition-colors hover:bg-background-50/15"
          >
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="absolute bottom-16 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2 md:left-6 md:translate-x-0">
          {featured.map((event, i) => (
            <button
              key={event.id}
              type="button"
              onClick={() => setIndex(i)}
              aria-label={`切换到第 ${i + 1} 个焦点赛事`}
              className={`h-2 rounded-full transition-all duration-300 ${
                i === index ? "w-8 bg-accent-500" : "w-2 bg-background-50/50"
              }`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}